import React from 'react';
import { Outlet } from 'react-router';
import './index.css';
import SideBar from './../../components/common/admin-sidebar';

function Admin() {
  return (
    <div className='admin-wrapper'>
      <div className='sidenav'>
        <SideBar />
      </div>
      <div className='main-content'>
        <Outlet />
      </div>
    </div>
  );
}

export default Admin;
